import { Theme, color, radius, rem } from '@thiememeulenhoff/lit-sdk';
import { PaletteColor, ThemeColor, Tint } from '@thiememeulenhoff/tokens';
import { css, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';
import { LabelVariant } from './label.types';

export const tag = tagName('label');
const theme = new Theme(tag);

const labelColors: Record<LabelVariant, ThemeColor | PaletteColor> = {
  neutral: 'grey',
  success: 'success',
  warning: 'warning',
  weergave: 'pink',
  info: 'teal',
};

const labelTints: Record<LabelVariant, Tint> = {
  neutral: 600,
  success: 600,
  warning: 600,
  weergave: 800,
  info: 800,
};

const labelVariant = (labelVariant: LabelVariant) => {
  const selector = unsafeCSS(`[variant=${labelVariant}]`);
  const labelColor = labelColors[labelVariant];
  const tint = labelTints[labelVariant];

  return css`
    :host(${selector}) {
      ${theme.props([
        ['background', `${labelColor}-background`, color(labelColor, 200)],
        ['color', `${labelColor}-color`, color(labelColor, tint)],
        [
          'border',
          `${labelColor}-border`,
          `${color(labelColor, 200)} solid ${rem(1)}`,
        ],
      ])};
    }

    :host(${selector}[disable-border]) {
      border: 0;
    }
  `;
};

export const label = css`
  :host {
    align-items: center;
    block-size: ${rem(32)};
    border-radius: ${radius('extra-large')};
    display: inline-flex;
    gap: ${rem(8)};
    justify-content: center;
    padding: ${rem(8, 16)};
    text-align: center;
  }

  :host([size='small']) {
    block-size: ${rem(24)};
    font-size: ${rem(14)};
    font-weight: 600;
    padding: ${rem(0, 12)};
  }

  :host([size='medium']) {
    font-size: ${rem(16)};
    padding: ${rem(8, 16)};
  }

  ${labelVariant('neutral')}
  ${labelVariant('success')}
  ${labelVariant('warning')}
  ${labelVariant('weergave')}
  ${labelVariant('info')}
`;
